import { useRef } from "react";
import { Control, Controller } from "react-hook-form";
import { PatternFormat } from "react-number-format";
import TextField from "@mui/material/TextField";
import Grid from "@mui/system/Grid";
import { isNull, isUndefined, trim } from "lodash";

import { Typography } from "@mui/material";
import fontWeight from "../styles/mui/fontWeight";
import colors from "../styles/colors/colors";
import { TextFieldStyle } from "../routes/CreatePriorAuth/style/style";

interface PhoneInfo {
  control: Control<any>;
  label?: string;
  name: string;
  style: any;
  disabled?: boolean;
  helper?: any;
  mandate?: boolean;
  isStandard?: boolean;
}

type AllProps = PhoneInfo;

export const PhoneNumberInput: React.FC<AllProps> = ({
  control,
  label,
  name,
  helper,
  style,
  disabled,
  isStandard
}: AllProps) => {
  const inputRefPhone = useRef<any>();
  const inputRefExt = useRef<any>();

  const handlePhoneNo = (event: React.ChangeEvent<HTMLInputElement>) => {
    const maxLength = 10;

    if (
      event.target.value &&
      trim(event.target.value).length === maxLength &&
      inputRefExt.current
    ) {
      inputRefExt.current.focus();
    }
  };

  return (
    <Grid container>
      <Grid size={{ xs: 12 }}>
        <Controller
          rules={helper}
          render={({
            field: { onChange, value, onBlur, ...fieldProps },
            fieldState: { error },
          }) => {
            let fieldError = false;
            let fieldErrorMessage = "";
            if (error && error.message) {
              fieldError = true;
              fieldErrorMessage = error.message;
            }

            return disabled ? (
              <TextField
              required={true}
              error={error !== undefined}
              sx={TextFieldStyle(false)}
              onChange={(e) => {
                onChange(e);
              }}
              disabled={disabled}
              value={value || ""}
              onBlur={onBlur}
              variant={isStandard ? "standard" : "outlined"}
              label={label ? label : ""}
            />) : (
              <PatternFormat
                name={fieldProps.name}
                disabled={disabled}
                format="(%%%) %%%-%%%%"
                patternChar="%"
                placeholder="(000) 000-0000"
                variant="standard"
                error={fieldError}
                value={!isNull(value) && !isUndefined(value) ? value : ""}
                helperText={fieldErrorMessage}
                required={helper && helper.required && label ? true : false}
                autoComplete="off"
                label={
                  <>
                    <Typography
                      variant="h4"
                      fontWeight={fontWeight[3]}
                      color={colors.fonts[2]}
                      lineHeight={"0.95rem"}
                    >
                      {label}
                    </Typography>
                  </>
                }
                fullWidth
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
                inputRef={inputRefPhone}
                onChange={(e: any) => {
                  onChange(e);
                  handlePhoneNo(e);
                }}
                onBlur={onBlur}
                customInput={TextField}
                sx={style}
              />
            );
          }}
          name={name}
          control={control}
        />
      </Grid>
    </Grid>
  );
};
